import { render, staticRenderFns } from "./ResponsiveTest.vue?vue&type=template&id=f48b411c&scoped=true"
import script from "./ResponsiveTest.vue?vue&type=script&lang=ts"
export * from "./ResponsiveTest.vue?vue&type=script&lang=ts"
import style0 from "./ResponsiveTest.vue?vue&type=style&index=0&id=f48b411c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48b411c",
  null
  
)

export default component.exports